/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cohere.integration.rpc.AppSettingsRpc
 */

export const installRpc = {
  serviceName: 'com.hubspot.cohere.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'sgaVyjFUsGD0ilHKLdpI9QAELmCErMr5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertApiKeyRpc = {
  serviceName: 'com.hubspot.cohere.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: '5Argc0QLeS7lD42UzcSlRgAELmCErMr5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};